import React from 'react';
import { cn } from '../lib/cn';

interface FloatingBoxProps {
  title: string;
  body: string;
  theme?: 'light' | 'dark';
  className?: string;
  visible?: boolean;
}

export default function FloatingBox({
  title,
  body,
  theme = 'light',
  className,
  visible = false,
}: FloatingBoxProps) {
  const surface = theme === 'dark'
    ? 'surface-dark text-avaris-light-solid'
    : 'surface-light text-black';

  return (
    <div
      className={cn(
        'floating-box flex h-[278px] w-[278px] flex-col justify-between p-6',
        visible && 'visible',
        surface,
        className
      )}
    >
      <p className="font-trispace type-h3">{title}</p>
      <p className="font-trispace type-body2">{body}</p>
    </div>
  );
}
